// extracted by mini-css-extract-plugin
export default {"container":"create-buttons_container__HzIpY","btn":"create-buttons_btn__tPx2t","icon":"create-buttons_icon__rp8F-","small":"create-buttons_small__NAALB"};